"use client";

import React from "react";
import { useNavigate } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@awesome.me/kit-70c1f0055f/icons/classic/light";
import type { ChatLinkEmbed } from "./types";
import { useOsActionsOptional } from "@/components/ui/os-layout/OsContext";
import { useOpenWindow } from "@/components/ui/os-layout/useWindow";
import { openArtifactById } from "@/components/artifacts/openArtifactDestination";
import { openTaskInMissionControl } from "./openTaskInMissionControl";

type EntityLinkChipProps = {
  embed: ChatLinkEmbed;
};

export function EntityLinkChip({ embed }: EntityLinkChipProps) {
  const navigate = useNavigate();
  const osActions = useOsActionsOptional();
  const openWindow = useOpenWindow();
  const inOsLayout = Boolean(osActions);

  const handleOpen = () => {
    if (embed.target === "mission") {
      if (inOsLayout) {
        openWindow({
          appId: "mission",
          title: embed.label,
          params: { missionId: embed.id },
        });
        return;
      }
      navigate(`/missions/${embed.id}`);
      return;
    }
    if (embed.target === "task" || embed.target === "thread") {
      openTaskInMissionControl(embed.id, { navigate, openWindow, inOsLayout });
      return;
    }
    if (embed.target === "artifact") {
      void openArtifactById(embed.id, openWindow, {
        mode: "view",
        title: embed.label,
      });
      return;
    }
    navigate(`/mission-control`);
  };

  return (
    <button
      type="button"
      onClick={handleOpen}
      className="inline-flex items-center gap-1.5 rounded-full border border-violet-200 bg-violet-50 px-3 py-1 text-sm text-violet-900 hover:bg-violet-100 dark:border-violet-800 dark:bg-violet-950/40 dark:text-violet-100"
    >
      <span className="truncate max-w-[280px]">{embed.label}</span>
      <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="size-3 shrink-0 opacity-70" />
    </button>
  );
}
